import { useMutation } from "@apollo/client";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import SelectWithQuerySearch from "../../../../components/SelectWithQuerySearch";
import { UPDATE_ADMIN, UPDATE_MANAGER } from "../../../../graphql/mutations";
import { FETCH_COMPANIES } from "../../../../graphql/queries";
import SelectProfile from "../../../../components/SelectProfile";
import RestrictionsPicker from "../../../../components/RestrictionsPicker";

export default function EditDialog({ open, handleClose, onEdit, data }) {

    const [profile, setProfile] = useState(null)

    // Setting mutation
    const [updateManager, { loading }] = useMutation(UPDATE_MANAGER);

    // Setting Formik
    const { handleSubmit, handleChange, setFieldValue, values, errors, resetForm } = useFormik({
        initialValues: ({
            ...data,
            filters: {},
            restrictionsForm: {
                restrictions: data?.restrictions,
                groupByRestrictionsTitle: []
            }
        }),
        onSubmit: (values) => {

            const restrictionsIds = Object.keys(values.restrictionsForm.restrictions)
                .filter((key) => values.restrictionsForm.restrictions[key] === true)
                .map((id) => parseInt(id, 10));

            // Chamando a mutation de edição
            updateManager({
                variables: {
                    id: values.id,
                    company_id: values.company && values.company.id,
                    name: values.name,
                    email: values.email,
                    password: values.password,
                    restriction_ids: restrictionsIds
                }
            }).then(() => {
                onEdit();
            })

        }
    });

    const handleChangeValue = (prop, value) => {
        setFieldValue(`restrictionsForm.${prop}`, value)
    }

    useEffect(function () {
        if (data) {
            resetForm();
            setFieldValue('id', data.id);
            setFieldValue('name', data.name);
            setFieldValue('email', data.email);
            setFieldValue('company', data.company);
            if (data.restrictions) {
                for (const item of data.restrictions) {
                    setFieldValue(`restrictionsForm.restrictions.${item.id}`, true);
                }
            }
        }
    }, [data]);

    useEffect(() => {
        if (profile) {
            setFieldValue('restrictionsForm.restrictions', [])
            if (profile.restrictions) {
                for (const item of profile.restrictions) {
                    setFieldValue(`restrictionsForm.restrictions.${item.id}`, true);
                }
            }
        }
    }, [profile])

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="scroll-dialog-title">Editar gerente</DialogTitle>

                <DialogContent style={{ padding: 16 }}>

                    <SelectWithQuerySearch
                        title="Empresa"
                        query={FETCH_COMPANIES}
                        fetchResult="fetchCompanies"
                        onChange={(company) => { setFieldValue('company', company) }}
                        fullWidth
                        value={values.company}
                    />

                    <TextField
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        value={values.name}
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoFocus
                        error={errors.name && true}
                        helperText={errors.name}
                    />

                    <TextField
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        value={values.email}
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoFocus
                        error={errors.email && true}
                        helperText={errors.email}
                    />

                    <TextField
                        type="password"
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        value={values.password}
                        required
                        fullWidth
                        id="password"
                        label="Nova senha"
                        name="password"
                        autoFocus
                        error={errors.password && true}
                        helperText={errors.password}
                    />

                    <SelectProfile
                        value={profile}
                        onChange={(item) => setProfile(item)}
                    />

                    <RestrictionsPicker {...{ handleChangeValue }} formValues={values.restrictionsForm} />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSubmit} variant="contained" color="primary" disabled={values.name == "" || loading}>
                        {loading && <CircularProgress size={14} style={{ marginRight: 12 }} />}
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
